import script from "./PeriodSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PeriodSelect.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__